import React, { useEffect, useState } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function Forgot_request() {
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const language = localStorage.getItem("i18nextLng");
const { i18n, t } = useTranslation();
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
    };
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // Request code for password reset
  const RequestCode = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${baseUrl}/request-code`,
        {
          email: email,
        //   source:"forgot-password"
        },
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        }
      );

      if (response.status === 200) {
        setError("");
        setMessage(response.data.message);
        setTimeout(() => {
          navigate("/verification", { state: { email: email, source: 1 } });
        }, 2000);
      }
    } catch (error) {
      setError(
        error.response?.data?.message || "An unexpected error occurred."
      );
    } finally {
      setIsLoading(false);
    }
  };

  
  

  return (
    <div
      className="flex flex-col gap-12"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        height:"100vh",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <div>
        <Nav />
      </div>

      {/* Login Container */}
      <div className="flex items-center justify-center w-full mb-8">
        <div className="shadow-[0px_6px_20px_rgba(0,0,0,0.7)] bg-white p-4 md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center mt-0 md:mt-2.5">
          {/* Title */}
          <h3 className="text-2xl sm:text-3xl mb-6 sm:mb-8 text-center font-semibold text-black mx-auto">
            
            {language === "fr" ? "Mot de passe oublié" : "Forgot Password"}

          </h3>

          {/* Login Form */}
          <form className="space-y-4" onSubmit={RequestCode}>
            {/* Input Fields */}
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
              placeholder="Email"
              required
            />
            {/* Submit Button */}
            <button
              type="submit"
              className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-black font-semibold border-none cursor-pointer mx-auto block hover:bg-[#333] text-white"

              disabled={isLoading}
            >
              {isLoading ? "Sending..." : `${language === "fr" ? "Envoyer le code" : "Send code"}
`}
            </button>
          </form>

          {/* Display Messages */}
          {message && <p className="text-green-500 mt-4">{message}</p>}
          {error && <p className="text-red-500 mt-4">{error}</p>}
        </div>
      </div>
    </div>
  );
}
